module.exports = __webpack_public_path__ + "img/checkbox-2.22a190cc.svg";